/**
 * @format
 */

import React from 'react';

import { Layout } from 'features/layout';
import { UsersTableContainer } from 'features/users';


/**
 * Users page component
 * Displays user table or user details based on selection
 */
const Users: React.FC = () => {
 

  return (
    <Layout>
       <UsersTableContainer />
    </Layout>
  );
};

export default Users;
